/* PARALIA · sitio nuevo. Piezas compartidas: cajones, carrito (Ajax API + Section Rendering) y formato de dinero.
   Cada sección carga su propio JS (assets/pa-*.js) y usa window.PA.

   Eventos (en document):
   - pa:cart:updated  detail: { cart }   después de agregar, cambiar o quitar
   - pa:cart:error    detail: { message }
   - pa:drawer:open / pa:drawer:close  detail: { id }

   Cajones: <div class="pa-drawer" id="X" data-pa-drawer>…</div>; abre con [data-pa-open="X"], cierra con [data-pa-close]. */
(() => {
  if (window.PA) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CART_SECTIONS = ['pa-cart-drawer'];

  const PA = {
    root,
    moneyFormat: (window.paSettings && window.paSettings.moneyFormat) || '${{amount}}',

    formatMoney(cents, format = PA.moneyFormat) {
      const value = Number(cents) / 100;
      const fmt = (n, dec) => n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
        if (k === 'amount_no_decimals') return fmt(Math.round(value), 0);
        if (k === 'amount_with_comma_separator') return fmt(value, 2).replace(/,/g, 'X').replace('.', ',').replace(/X/g, '.');
        return fmt(value, value % 1 ? 2 : 0);
      });
    },

    /* ---------- cajones ---------- */
    overlay: null,
    openDrawer(id) {
      const d = document.getElementById(id);
      if (!d) return;
      document.querySelectorAll('.pa-drawer.is-open').forEach(o => { if (o !== d) PA.closeDrawer(o.id, true); });
      PA.lastFocus = document.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      PA.overlay.classList.add('is-open');
      document.body.classList.add('pa-locked');
      const f = d.querySelector('[data-pa-autofocus]') || d.querySelector('button, [href], input, select, textarea');
      if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
      document.querySelectorAll(`[data-pa-open="${id}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
      document.dispatchEvent(new CustomEvent('pa:drawer:open', { detail: { id } }));
    },
    closeDrawer(id, keepOverlay = false) {
      const d = id ? document.getElementById(id) : document.querySelector('.pa-drawer.is-open');
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.querySelectorAll(`[data-pa-open="${d.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (!keepOverlay) {
        PA.overlay.classList.remove('is-open');
        document.body.classList.remove('pa-locked');
        if (PA.lastFocus && PA.lastFocus.focus) PA.lastFocus.focus({ preventScroll: true });
      }
      document.dispatchEvent(new CustomEvent('pa:drawer:close', { detail: { id: d.id } }));
    },

    /* ---------- carrito ---------- */
    async fetchJSON(url, opts = {}) {
      const res = await fetch(url, { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...opts });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) {
        const message = data.description || data.message || 'No se pudo actualizar el carrito.';
        document.dispatchEvent(new CustomEvent('pa:cart:error', { detail: { message } }));
        throw new Error(message);
      }
      return data;
    },
    async getCart() { return PA.fetchJSON(`${root}cart.js`); },

    /* Pide las secciones del carrito ya renderizadas en la misma llamada (Section Rendering API). */
    withSections(body) { return { ...body, sections: CART_SECTIONS.join(','), sections_url: window.location.pathname }; },

    renderSections(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll(`[data-pa-section="${id}"]`).forEach(target => {
          const fresh = doc.querySelector(`[data-pa-section="${id}"]`);
          if (fresh) target.innerHTML = fresh.innerHTML;
        });
      });
    },

    async refresh() {
      const res = await fetch(`${root}?sections=${CART_SECTIONS.join(',')}`);
      PA.renderSections(await res.json());
      const cart = await PA.getCart();
      PA.updateCount(cart);
      document.dispatchEvent(new CustomEvent('pa:cart:updated', { detail: { cart } }));
      return cart;
    },

    async add(items, { open = true } = {}) {
      const list = Array.isArray(items) ? items : [items];
      const data = await PA.fetchJSON(`${root}cart/add.js`, { method: 'POST', body: JSON.stringify(PA.withSections({ items: list })) });
      PA.renderSections(data.sections);
      const cart = await PA.getCart();
      PA.updateCount(cart);
      document.dispatchEvent(new CustomEvent('pa:cart:updated', { detail: { cart, added: data.items } }));
      if (open) PA.openDrawer('PaCartDrawer');
      return cart;
    },

    async change(line, quantity) {
      const data = await PA.fetchJSON(`${root}cart/change.js`, { method: 'POST', body: JSON.stringify(PA.withSections({ line, quantity })) });
      PA.renderSections(data.sections);
      PA.updateCount(data);
      document.dispatchEvent(new CustomEvent('pa:cart:updated', { detail: { cart: data } }));
      return data;
    },

    async update(body) {
      const data = await PA.fetchJSON(`${root}cart/update.js`, { method: 'POST', body: JSON.stringify(PA.withSections(body)) });
      PA.renderSections(data.sections);
      PA.updateCount(data);
      document.dispatchEvent(new CustomEvent('pa:cart:updated', { detail: { cart: data } }));
      return data;
    },

    updateCount(cart) {
      document.querySelectorAll('[data-pa-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    },
  };

  window.PA = PA;

  const init = () => {
    PA.overlay = document.querySelector('[data-pa-overlay]');
    if (!PA.overlay) {
      PA.overlay = document.createElement('div');
      PA.overlay.className = 'pa-overlay';
      PA.overlay.setAttribute('data-pa-overlay', '');
      document.body.appendChild(PA.overlay);
    }
    PA.overlay.addEventListener('click', () => PA.closeDrawer());

    document.addEventListener('click', e => {
      const opener = e.target.closest('[data-pa-open]');
      if (opener) { e.preventDefault(); PA.openDrawer(opener.getAttribute('data-pa-open')); return; }
      const closer = e.target.closest('[data-pa-close]');
      if (closer) { e.preventDefault(); PA.closeDrawer(closer.closest('.pa-drawer') ? closer.closest('.pa-drawer').id : null); }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && document.querySelector('.pa-drawer.is-open')) PA.closeDrawer(); });

    /* Formularios de producto genéricos: <form data-pa-product-form action="/cart/add">. Las secciones pueden usar el suyo. */
    document.addEventListener('submit', async e => {
      const form = e.target.closest('form[data-pa-product-form]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      btn && btn.classList.add('is-loading');
      try {
        const fd = new FormData(form);
        const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
        const props = {};
        for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
        if (Object.keys(props).length) item.properties = props;
        await PA.add(item);
      } catch (err) {
        const msg = form.querySelector('[data-pa-form-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      } finally {
        btn && btn.classList.remove('is-loading');
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
